module.exports = __webpack_public_path__ + "img/IDCard-positive.ccbf90a1.png";